import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { find } from 'lodash';
// import scrollToComponent from 'react-scroll-to-component';

import { getHotels } from 'modules/hotels';
import { selectHotels } from 'common/selectors';

import Navigation from 'components/NavigationRelative';
import Header from './Header';
import Perks from './Perks';
import Featured from './Featured';
// import Quotes from './Quotes';
import Rooms from './Rooms';
import PartnerHotels from './PartnerHotels';
import { hotelsMeta } from './constants';
import { arrayMergeByKey } from './helpers';
import { OfficialHotel as S } from './styles';

class OfficialHotelPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.props = this.getCurrentHotels();
  }
  componentDidMount() {
    let urlHash = window.location.hash;
    urlHash = urlHash.replace('#', '');
    setTimeout(() => { this.scrollTo(urlHash); }, 2000);
  }
  componentDidUpdate() {
    let urlHash = window.location.hash;
    urlHash = urlHash.replace('#', '');
    setTimeout(() => { this.scrollTo(urlHash); }, 2000);
  }

  getCurrentHotels = () => {
    this.props.getHotels();
  };
  scrollTo = () => {
    // const hotel = document.querySelector(`${hash}`);
    // scrollToComponent(hotel, { offset: -65, align: 'top' });
  };

  render() {
    const hotels = arrayMergeByKey(this.props.hotels, hotelsMeta, 'name');
    const featured = find(hotels, { name: 'Centara Grand At Central World' });
    return (
      <S.Wrapper>
        <Navigation />
        <Header />
        <Perks />
        {hotels.length > 0 && <Featured hotel={featured} />}
        {/* {<Quotes />} */}
        {featured.room_set && <Rooms roomsData={featured.room_set} deeplink={featured.deeplink} />}
        <PartnerHotels hotels={hotels} />
      </S.Wrapper>
    );
  }
}

OfficialHotelPage.propTypes = {
  hotels: PropTypes.array.isRequired,
  getHotels: PropTypes.func.isRequired,
};

const mapStateToProps = createStructuredSelector({
  hotels: selectHotels,
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    getHotels,
  }, dispatch);
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(OfficialHotelPage);



// WEBPACK FOOTER //
// ./src/containers/Hotel/index.js